import { NewButton, NewButtonSize, NewButtonVariant } from "@bale/ui";
import PackagesModal from "components/content/packagesPage/PackagesModal";
import { strings } from "intl/fa";
import { useState } from "react";
import { createPortal } from "react-dom";
import { sendYandexGoal, YandexGoal } from "yandex/yandex";
import styles from "./Sidebar.module.scss";

const PackagesInfo: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [showPackagesModal, setShowPackagesModal] = useState(false);
  const buttonClickHandler = () => {
    sendYandexGoal(YandexGoal.OpenPackagesModal);
    setShowPackagesModal(true);
  };

  return (
    <>
      <div className={styles.BlueCard}>
        <p className={styles.Title}>{strings.side_bar.package.title}</p>
        <p className={styles.Description}>
          {strings.side_bar.package.description}
        </p>
        <NewButton
          // color={"#6D00D4"}
          size={NewButtonSize.SMALL}
          className={styles.ButtonText}
          onClick={buttonClickHandler}
          variant={NewButtonVariant.OUTLINED}
          style={{ width: "100%" }}
        >
          {strings.side_bar.package.more_info}
        </NewButton>
        {showPackagesModal &&
          createPortal(
            <PackagesModal onClose={() => setShowPackagesModal(false)} />,
            document.getElementById("fullscreen-modal")!
          )}
      </div>
    </>
  );
};

export default PackagesInfo;
